import { render, staticRenderFns } from "./CompanyProfileLeftSection.vue?vue&type=template&id=2bbfa854&scoped=true"
import script from "./CompanyProfileLeftSection.vue?vue&type=script&lang=js"
export * from "./CompanyProfileLeftSection.vue?vue&type=script&lang=js"
import style0 from "./CompanyProfileLeftSection.vue?vue&type=style&index=0&id=2bbfa854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbfa854",
  null
  
)

export default component.exports